import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import './order_with_us.css'
import { useState } from 'react';
import emailjs from '@emailjs/browser'



function Order() {
  const[firstname,setFirstname] = useState();
  const[lastname,setLastname] = useState();
  const[email,setEmail] = useState();
  const[phone,setPhone] = useState();
  const[date,setDate] = useState();
  const[message,setMessage] = useState();
  const[submitStatus = "request-not-submited",setSubmitStatus] = useState();

  if (submitStatus == "request-submited") {
    setTimeout(() => {
      setSubmitStatus("request-not-submited") ;
    }, "5000");
  }
  
  const sendEmailToTana = (e) => {
    e.preventDefault();
// Send email to tana
    emailjs.sendForm('service_e5hz53f','template_8jk5s2h',e.target,'CCYTDqyurWMQ8KOI5')
// Send confimation email to customer
    emailjs.sendForm('service_e5hz53f','template_qmioreo',e.target,'CCYTDqyurWMQ8KOI5')
    setSubmitStatus("request-submited")
    setFirstname("")
    setLastname("")
    setEmail("")
    setPhone("")
    setDate("")
    setMessage("")
  }

  return(

    <div className='order-screen'>
      <Header></Header>
      <div className="order-main-container">
        <div className='order-top-paragraph'>
          <p>
            We are currently taking orders by email or phone. Please fill out the form below or give us a call at <strong>586 489-9295</strong>. We look forward to helping you with your
            needs. Look at our gallery for inspiration.

            <br/> <br/> Please allow 24-48 hours for us to review your request and contact you. Once your order is confirmed,
             a deposit will be required to secure your chosen date. Please be aware that orders can not be held on our calendar without a deposit.

             <br/><br/> Additionally, a deposit is non refundable for cancelations made within one week of the scheduled fulfilment date.
             
          </p>
        </div>
        <div  className='form-div'>
        <form className='order-form' onSubmit={sendEmailToTana}>
        <label className='first'>First Name
         :</label><br></br><br></br>
          <input className='firsti' 
                type="text" 
                required 
                name='firstname'
                value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  /><br></br><br></br>

        <label className='last'>Last Name :</label><br></br><br></br>
          <input className='lasti' 
                type="text" 
                required
                name='lastname' 
                value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  /><br></br>    <br></br>              
        <label className='email'>Email :</label><br></br><br></br>
          <input className='emaili' 
                type="text" 
                required 
                name='email'
                value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  /><br></br>   <br></br>       
        
        <label className='phone'>Phone Number :</label><br></br><br></br>
          <input className='phonei' 
                type="text" 
                required 
                name='phone'
                value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  /><br></br>  <br></br>      
        <label className='date'>Event Date :</label><br></br><br></br>
          <input className='datei'
                type="date" 
                required 
                name='date'
                value={date}
                  onChange={(e) => setDate(e.target.value)}
                  /><br></br> <br></br> 

        <label>Please tell us more about your event <br></br> and how we can make it more memorable:
        {/*  <br></br>  Mention the products you wish to order and <br></br> we will get back to you as soon as we possible  */}
        </label><br></br><br></br>
        <textarea className = "order-message-input" 
                  type="text"
                  required
                  name='message'
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  />
        <br></br>
        <br></br>

        <button className='Submit-button'
                type='submit'
                >Submit</button>

        </form>
        <h4 className={submitStatus}>Check your inbox for an email confirmation</h4>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
  }
  
  export default Order;